const Joi = require("joi");

const postSchema = (data) => {
 const schema = Joi.object({
  title: Joi.string().trim().required().messages({
   "string.empty": "Please enter Title.",
   "any.required": "Please enter Title.",
  }),

  description: Joi.string()
   .trim()
   .min(1)
   .custom((value, helpers) => {
    const strippedContent = value
     .replace(/<\/?[^>]+(>|$)/g, "")
     .replace(/&nbsp;/g, "")
     .replace(/\s+/g, "")
     .trim();

    if (!strippedContent || strippedContent.length === 0) {
     return helpers.message("Please enter Description.");
    }

    return value;
   })
   .required()
   .messages({
    "string.empty": "Please enter Description.",
    "any.required": "Please enter Description.",
    "string.min": "Please enter Description.",
   }),

 }).unknown(true);

 return schema.validate(data, {
  abortEarly: false,
 });
};

module.exports = postSchema;
